// extracted by mini-css-extract-plugin
export default {"defaultFileIcon":"drag-and-drop_defaultFileIcon__f5Hub"};